
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>M.Sc. Computer Science</h1>
                </div>
            </div>
        </div>          
    </div>  
</section>   

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Eligibility </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Duration</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Subjects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Affiliation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Scope  and Prospects</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Eligibility </h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>Science Graduate or any other equivalent examination from a recognized university. </p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Duration
                            </h3>
                           
                        </div>  
                        <div class="text-left">                        
                            <p>2 years ( 4 Semesters)</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">                                
                        <div class="inner-title"  >
                            <h3>Subjects
                            </h3>
                           
                        </div>
                        <p>4/5 subjects per semester </p>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">M.Sc. (CS) Part I</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 1</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 2</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1T1</td>
                                        <td>Discrete Mathematical  Structure
                                        </td>
                                        <td>2T1</td>
                                        <td>Windows Programming using VC++
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1T2</td>
                                        <td>Programming in Java</td>
                                        <td>2T2</td>
                                        <td>Theory of Computation and Compiler Construction
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1T3</td>
                                        <td>Digital Electronics and  Microprocessor
                                        </td>
                                        <td>2T3</td>
                                        <td>Computer Architecture and  Organization
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1T4</td>
                                        <td>Advanced DBMS and  Administration
                                        </td>
                                        <td>2T4</td>
                                        <td>Computer Graphics</td>
                                    </tr>
                                    <tr>
                                        <td>1P1</td>
                                        <td>Based on theory paper- 1T1  and 1T2</td>
                                        <td>2P1</td>
                                        <td>Based on theory paper- 2T1  and 2T2</td>
                                    </tr>
                                    <tr>
                                        <td>1P2</td>
                                        <td>Based on theory paper- 1T3  and 1T4</td>
                                        <td>2P2</td>
                                        <td>Based on theory paper- 2T3  and 2T4</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">M.Sc. (CS) Part II</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 3</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 4</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>3T1</td>
                                        <td>Data Communication and
                                            Networks
                                        </td>
                                        <td>4T1</td>
                                        <td>Data Mining</td>
                                    </tr>
                                    <tr>
                                        <td>3T2</td>
                                        <td>Software Engineering</td>
                                        <td>4T2</td>
                                        <td>Artificial Intelligence & 
                                            Expert System
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3T3
                                            (Core Elective)
                                        </td>
                                        <td>CE1-1 Neural Network 
                                            CE1-2 Multimedia Technologies 
                                            CE1-3 ASP.NET
                                        </td>
                                        <td>4T3
                                            (Core
                                            Elective 2)
                                        </td>
                                        <td>CE2-1 Design and Analysis of Algorithm
                                            CE2-2 Embedded System 
                                            CE2-3 Pattern Recognition
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3T4
                                            (Foundation
                                            Course 1/
                                            Core(Disci
                                            pline
                                            Centric)1)
                                        </td>
                                        <td>FC1 Operating System Concepts 
                                            CDC1 Mobile Computing
                                        </td>
                                        <td>4T4
                                            (Foundation
                                            Course 2/
                                            Core(Disci
                                            pline
                                            Centric)2)
                                        </td>
                                        <td>FC2 Advances in Information Technology
                                            CDC2 Parallel Computing
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3P1</td>
                                        <td>Based on theory paper- 3T1  and 3T2</td>
                                        <td>4P1</td>
                                        <td>Based on theory paper- 4T1  and 4T2</td>
                                    </tr>
                                    <tr>
                                        <td>3P2</td>
                                        <td>Based on theory paper- 3T3  and 3T4</td>
                                        <td>4P2</td>
                                        <td>Based on theory paper- 4T3  and 4T4</td>
                                    </tr>
                                    <tr>
                                        <td>Seminar 3</td>
                                        <td>Seminar</td>
                                        <td>Seminar 3</td>
                                        <td>Seminar</td>
                                    </tr>
                                    <tr>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>Project</td>
                                        <td>Project
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">                                
                        <div class="inner-title"  >
                            <h3>Affiliation
                            </h3>
                           
                        </div> 
                        <div class="text-left">                         
                            <p>RTM Nagpur University </p>
                        </div> 
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">                                
                        <div class="inner-title"  >
                            <h3>Scope  and Prospects
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Scope :</strong>  IT Companies    </li>
                            <li><strong>Prospects:</strong> Software Developer, Software tester, Self Business of Software selling.</li>
                        </ul>
                    </div>
                </div>                
                <div class="text-center mt-5">
                    <a class="button-text" href="https://raisoni.nopaperforms.com/rgi" target="_blank">Apply Now</a>
                </div>
            </div>
        </div>
    </div>
</section>

